<template>
  <div class="dialog">
    <el-dialog
      class="formExportAis"
      :visible.sync="changVisible"
      :modal="false"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="$onClose"
      :destroy-on-close="true"
    >
      <el-form id="form_downloadPhoto" method="post"> </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import * as CApi from "@/api/constant_api.js";

export default {
  data() {
    return {
      changVisible: false,
      loading: true,
      token: localStorage.getItem("token"),
      logIds: ""
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    show(ids, filter) {
      if (ids == undefined && filter == undefined) return;
      if (ids.length == 0) ids = ["all"];
      this.logIds = JSON.stringify(ids);
      console.log(this.logIds);
      this.changVisible = true;
      let params = "?token=" + this.token + "&log_ids=" + this.logIds;

      if (filter && filter.where_name != "") {
        params += "&where_name=" + filter.where_name;
      }
      if (filter && filter.where_student_no != "") {
        params += "&where_student_no=" + filter.where_student_no;
      }
      this.$nextTick(() => {
        const from = document.getElementById("form_downloadPhoto");
        from.action = URL_PATH + CApi.api_downloadPhoto + params;
        from.submit();
        this.close();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.formExportAis {
  visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/exportUserPhotoDialog.vue